<template>
  <div class="CampaignEditorDoc">
    <h1>Single Collapse</h1>
    <campaign-editor-group id="collapse" :title="'Lifestyle'" :count="90" :price="150000000" />
    <campaign-editor-group id="collapse" :title="'Videotron'" :count="40" :price="1500000000" />
    <campaign-editor-group id="collapse" :title="'SPBU'" :count="90" :price="150000000" />
    <h1>Multiple Collapse</h1>
    <campaign-editor-group :title="'Lifestyle'" :count="90" :price="150000000" />
    <campaign-editor-group :title="'Videotron'" :count="40" :price="1500000000" />
    <campaign-editor-group :title="'SPBU'" :count="90" :price="150000000" />
  </div>
</template>

<script>
import Vue from 'vue'

import CampaignEditorGroup from '@/components/CampaignEditorGroup'

export default {
  name: 'adx-campaign-editor-doc',
  components: {
    'campaign-editor-group': CampaignEditorGroup,
  },
  mounted(){
    this.$nextTick(function () {
      Vue.$broker.$on("collapse", this.check.bind(this));
    });
  },
  methods: {
    check(sender){
      this.$children.forEach(child => {
        if(child._uid != sender._uid && child.$el.id == 'collapse'){
          child._data.isCollapse = false;
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>